/**
 * Public pickup and returns policy.
 * Google Search Console Shopping → Returns needs this URL.
 * Copy matches the live shop: website checkout is pickup only.
 */
import { Link } from 'react-router-dom';
import { usePageSeo } from '../utils/seo';
import { PAGE_SEO } from '../utils/seoDefaults';
import { BAKERY_LOCAL } from '../utils/bakeryLocal';
import { UBER_EATS_STORE_URL } from '../constants/ubereats';

export default function PickupAndReturns() {
  usePageSeo({
    ...PAGE_SEO.pickupAndReturns,
    og: {
      type: 'website',
      title: PAGE_SEO.pickupAndReturns.title,
      description: PAGE_SEO.pickupAndReturns.description,
    },
  });

  return (
    <div className="bg-bakery-cream min-h-screen">
      <div className="container-custom section-padding max-w-3xl">
        <h1 className="text-3xl font-display font-bold text-gray-900 mb-2">
          Pickup and returns
        </h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: August 13, 2026</p>

        <div className="prose prose-gray max-w-none space-y-6 text-gray-700">
          <section>
            <h2 className="text-xl font-semibold text-gray-900">Pickup at the bakery</h2>
            <p>
              {BAKERY_LOCAL.name} website checkout is pickup only. We do not ship website
              orders. Pick up at {BAKERY_LOCAL.addressFull}. Phone {BAKERY_LOCAL.telephone}.
              Hours: {BAKERY_LOCAL.hoursShort}
            </p>
            <p>
              <Link to="/order" className="text-primary-700 hover:underline">
                Order for pickup
              </Link>
              {' · '}
              <Link to="/contact" className="text-primary-700 hover:underline">
                Contact
              </Link>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900">Delivery</h2>
            <p>
              Delivery is through{' '}
              <a
                href={UBER_EATS_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary-700 hover:underline"
              >
                Uber Eats
              </a>
              . Uber Eats has its own fees and policies. Website cart checkout is not
              delivery.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900">Returns</h2>
            <p>
              Bakery items are perishable. We do not accept mail returns. After pickup,
              food generally cannot be returned. If something is wrong with an order, call{' '}
              {BAKERY_LOCAL.telephone} or email {BAKERY_LOCAL.email} the same day when you
              can.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900">Cancelled paid orders</h2>
            <p>
              If we cancel an order you already paid for, contact us at{' '}
              {BAKERY_LOCAL.telephone} or {BAKERY_LOCAL.email} so we can assist with a
              refund if one applies.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900">Custom cakes</h2>
            <p>
              Custom cakes need 72 hour notice. Once we start a custom cake, we usually
              cannot reverse it. Call before the pickup date if your plans change.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
